
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    experiences: [
      { name: 'All Experiences', href: '/experiences' },
      { name: 'Mountain Retreats', href: '/experiences/mountain' },
      { name: 'Forest Escapes', href: '/experiences/forest' },
      { name: 'Lakeside Adventures', href: '/experiences/lakeside' },
      { name: 'Desert Sanctuaries', href: '/experiences/desert' }
    ],
    investments: [
      { name: 'Investment Opportunities', href: '/investments' },
      { name: 'Investment Packages', href: '/investment-packages' },
      { name: 'Investment Process', href: '/investments/process' },
      { name: 'Portfolio & Returns', href: '/investments/returns' },
      { name: 'Start Investing', href: '/start-investing' }
    ],
    business: [
      { name: 'Dealership Opportunities', href: '/dealership' },
      { name: 'Consultation Services', href: '/consultation' },
      { name: 'About Us', href: '/about' },
      { name: 'Sustainability', href: '/sustainability' },
      { name: 'Press & Media', href: '/press' }
    ],
    support: [
      { name: 'Contact Us', href: '/contact' },
      { name: 'Book Experience', href: '/book' },
      { name: 'Careers', href: '/careers' },
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Terms of Service', href: '/terms' }
    ]
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-2 mb-6">
              <img 
                src="https://static.readdy.ai/image/22d69ea1c69f4444f58b39b98de3f50c/80f4d1f39b822a3424440f3dd7d968b8.jpeg" 
                alt="GLAMPIRE Logo" 
                className="h-8 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Creating extraordinary glamping experiences and profitable investment opportunities in the world's most beautiful natural settings.
            </p>
            <div>
              <h3 className="text-lg font-semibold text-white mb-4">Follow Us</h3>
              <div className="flex space-x-4">
                <a 
                  href="https://www.facebook.com/share/1K9aiNB9A9/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-white hover:bg-white hover:text-emerald-600 transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill"></i>
                </a>
                <a 
                  href="https://www.instagram.com/oedglampingncamping" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-white hover:bg-white hover:text-emerald-600 transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line"></i>
                </a>
                <a 
                  href="https://x.com/oedtinyhomekits" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-white hover:bg-white hover:text-emerald-600 transition-colors cursor-pointer"
                >
                  <i className="ri-twitter-x-line"></i>
                </a>
                <a 
                  href="https://youtube.com/@tinyhomeinvestmentgroup" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-white hover:bg-white hover:text-emerald-600 transition-colors cursor-pointer"
                >
                  <i className="ri-youtube-line"></i>
                </a>
                <a 
                  href="https://www.linkedin.com/in/oedtinyhomes" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-white hover:bg-white hover:text-emerald-600 transition-colors cursor-pointer"
                >
                  <i className="ri-linkedin-fill"></i>
                </a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Experiences</h3>
            <ul className="space-y-3">
              <li><Link to="/experiences/mountain" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">Mountain Retreats</Link></li>
              <li><Link to="/experiences/forest" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">Forest Sanctuaries</Link></li>
              <li><Link to="/experiences/lakeside" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">Lakeside Escapes</Link></li>
              <li><Link to="/experiences/desert" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">Desert Oasis</Link></li>
              <li><Link to="/book" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">Book Now</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Investments</h3>
            <ul className="space-y-3">
              <li><Link to="/investments" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">Current Opportunities</Link></li>
              <li><Link to="/investments/portfolio" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">Portfolio</Link></li>
              <li><Link to="/investments/returns" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">Returns &amp; Performance</Link></li>
              <li><Link to="/investments/process" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">Investment Process</Link></li>
              <li><Link to="/partnership" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">Partner With Us</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">About OED</Link></li>
              <li><Link to="/sustainability" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">Sustainability</Link></li>
              <li><Link to="/careers" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">Careers</Link></li>
              <li><Link to="/press" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">Press &amp; Media</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">Contact Us</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} OED Glamping Retreat Developments. All rights reserved.
            </div>
            <div className="flex items-center space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer">
                Terms of Service
              </Link>
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
